import React from 'react';
import { DARK_BASE } from './constants';
import FilterDropdown from './FilterDropdown';

interface DashboardHeaderProps {
  projectNames: string[];
  selectedProjects: string[];
  onToggleProject: (v: string) => void;
  onClearProjects: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  projectNames,
  selectedProjects,
  onToggleProject,
  onClearProjects
}) => (
  <div
    className="d-flex justify-content-between align-items-center mb-4 px-3 py-2"
    style={{ background: DARK_BASE, borderRadius: 'var(--bs-border-radius-lg)', color: '#fff' }}
  >
    
    <div className="d-flex gap-2 flex-wrap">
      <FilterDropdown
        label={`All projects (${projectNames.length})`}
        options={projectNames}
        selected={selectedProjects}
        onToggle={onToggleProject}
        onClear={onClearProjects}
      />
    </div>
  </div>
);

export default DashboardHeader;
